import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "components-layout-demo-custom-trigger" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Dashboard", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Payments", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Invoice", -1)
const _hoisted_5 = { class: "ant-menu-item-div" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Vendor Profile", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_WalletOutlined = _resolveComponent("WalletOutlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      mode: "inline",
      class: "side",
      style: {"padding-top":"0px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_menu_item, {
          key: "1",
          class: _normalizeClass([_ctx.$route.path == '/dashboard' ? 'ant-menu-item-selected' : ''])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/dashboard" }, {
              default: _withCtx(() => [
                _createVNode(_component_HomeOutlined),
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_a_sub_menu, { key: "system-settings-submenu" }, {
          title: _withCtx(() => [
            _createVNode(_component_WalletOutlined, { class: "menu-icon" }),
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, {
              key: "/submitted/invoice",
              class: _normalizeClass([_ctx.$route.path == '/submitted/invoice' ? 'ant-menu-item-selected' : '']
          )
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/submitted/invoice" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_menu_item, {
          key: "4",
          class: _normalizeClass([_ctx.$route.path == '/profile' ? 'ant-menu-item-selected' : ''])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, { to: "/profile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserOutlined, { class: "menu-icon" }),
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}